module.exports = "<order-summary-count-and-instructions-tag ctrl=\"ctrl\"></order-summary-count-and-instructions-tag>\n<hr class=\"hr--thin\"/>\n<order-summary-items ctrl=\"ctrl\" lines=\"diner.lines\"></order-summary-items>\n<order-summary-coupons ctrl=\"ctrl\"></order-summary-coupons>\n<order-summary-napkins-and-utensils ctrl=\"ctrl\"></order-summary-napkins-and-utensils>\n<order-summary-adjustments ctrl=\"ctrl\"></order-summary-adjustments>\n<order-summary-totals ctrl=\"ctrl\"></order-summary-totals>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/orderSummary.html
// module id = 781
// module chunks = 0